import React from 'react';

class DemoCards extends React.Component {
  render() {
    return (
      <section className="demo-section">
        <h1 className="text-weight-light sp-xs-top-3 sp-xs-bottom-2 text-accent">Cards</h1>
        <div className="row sp-xs-bottom-2">
          <div className="col-md-4">
            <div className="card">
              <div className="card-header">
                Featured
              </div>
              <div className="card-block">
                <h4 className="card-title">Special title treatment</h4>
                <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                <a href="#" className="btn btn-primary">Go somewhere</a>
              </div>
              <div className="list">
                <div className="list-item">
                  Teste
                </div>
                <a className="list-item list-item-action">
                  Teste
                </a>
                <div className="list-item">
                  Teste
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card card-block">
              <h4 className="card-title">Card title</h4>
              <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              <a href="#" className="btn btn-outline-primary card-link">Another link</a>
              <a href="#" className="card-link">Card link</a>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card">
              <div className="card-header">
                Featured
              </div>
              <div className="card-block">
                <h4 className="card-title">Special title treatment</h4>
                <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                <a href="#" className="btn btn-primary">Go somewhere</a>
              </div>
              <div className="list">
                <div className="list-item">
                  Teste
                </div>
                <div className="list-item">
                  Teste
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default DemoCards;



/** WEBPACK FOOTER **
 ** ./src/components/demo/DemoCards.js
 **/